export default __webpack_public_path__ + "e32d7b0f4a8f713adfdd8f0cd656cce5.png";